<template>
  <!-- <dx-popup
    :id="id"
    :key="freightOrderHistoryKey"
    :visible.sync="isFreightOrderHistoryShown"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :show-title="true"
    :height="500"
    :title="$t('Freight order history')"
  > -->
  <dx-data-grid
    ref="freightOrderHistoryGrid"
    :data-source="freightOrderHistory"
  >
    <!-- <dx-column
      data-field="modify_date"
      :caption="$t('modify date')"
      data-type="date"
    /> -->
    <!-- <dx-column
      data-field="user.first_name"
      :caption="$t('First name')"
    />
    <dx-column
      data-field="user.last_name"
      :caption="$t('Last name')"
    />
    <dx-column
      data-field="user.username"
      :caption="$t('Username')"
    /> -->
    <dx-column
      data-field="status.name"
      :caption="$t('Status')"
      cell-template="status-template"
    />
    <dx-column
      data-field="modify_date"
      :caption="$t('Modify date')"
      data-type="date"
    />
    <dx-column
      data-field="status_comment"
      :caption="$t('Status comment')"
    />
    <template #status-template="{ data }">
      {{ $t(data.data.status.name) }}
    </template>
    <dx-group-panel :visible="false" />
    <dx-header-filter :visible="false" />
    <dx-search-panel
      :visible="false"
      :highlight-case-sensitive="false"
    />
    <dx-state-storing
      :enabled="true"
      type="localStorage"
      storage-key="freightOrderHistory"
    />
    <dx-paging :page-size="20" />
    <dx-pager
      :show-page-size-selector="true"
      :allowed-page-sizes="[10, 15, 20, 50]"
    />
  </dx-data-grid>
  <!-- <dx-toolbar-item
      widget="dxButton"
      toolbar="top"
      location="after"
      :options="closeButtonOptions"
      class="close-text-button"
    />
  </dx-popup> -->
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxGroupPanel,
  DxSearchPanel,
  DxStateStoring,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid';

// import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';

import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import createCustomStore from '@/utils/create-custom-store';

export default {
  name: 'FreightOrderHistoryModal',
  components: {
    DxDataGrid,
    DxColumn,
    DxGroupPanel,
    DxSearchPanel,
    DxHeaderFilter,
    DxStateStoring,
    DxPaging,
    DxPager,
    // DxPopup,
    // DxToolbarItem,
  },
  props: {
    id: [Number, String],
  },
  data: vm => ({
    freightOrderHistory: createCustomStore(`tracking/api/freight_orders/${vm.id}/history/`),
  }),
  computed: {
    closeButtonOptions() {
      return {
        text: 'Закрыть',
        icon: 'ace-icon icon-close',
        class: 'close-text-button',
        onClick: () => {
          this.isVisible = false;
        },
      };
    },
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-refresh',
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    refreshDataGrid() {
      this.$refs.freightOrderHistoryGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.freightOrderHistoryGrid.instance.clearFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
